module.exports = __webpack_public_path__ + "img/BUGATTI.667c32f.jpg";